import { useEffect, useState } from "react";
import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "~/components/ui/button";
import { Switch } from "~/components/ui/switch";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const isDark = resolvedTheme === "dark";

  if (!mounted) {
    return (
      <div className="flex items-center gap-2 shrink-0" aria-hidden suppressHydrationWarning>
        <Sun className="h-4 w-4 text-muted-foreground opacity-40" />
        <div className="h-6 w-11 rounded-full bg-muted opacity-50" />
        <Moon className="h-4 w-4 text-muted-foreground opacity-40" />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1 sm:gap-2 shrink-0">
      <div className="flex items-center gap-2 rounded-md border border-border bg-muted/40 px-2 py-1">
        <Sun className="h-4 w-4 text-muted-foreground shrink-0" aria-hidden />
        <Switch
          id="theme-dark-mode"
          checked={isDark}
          onCheckedChange={(checked) => setTheme(checked ? "dark" : "light")}
          aria-label="Dark mode"
        />
        <Moon className="h-4 w-4 text-muted-foreground shrink-0" aria-hidden />
      </div>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="h-9 w-9 shrink-0"
            aria-label="Theme source"
            title="Light, dark, or follow system"
          >
            {theme === "dark" ? (
              <Moon className="h-5 w-5" />
            ) : theme === "light" ? (
              <Sun className="h-5 w-5" />
            ) : (
              <Monitor className="h-5 w-5" />
            )}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[10rem]">
          <DropdownMenuRadioGroup value={theme ?? "system"} onValueChange={setTheme}>
            <DropdownMenuRadioItem value="light">Light</DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="dark">Dark</DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="system">System</DropdownMenuRadioItem>
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
